import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import hotel2 from "./Assets/hotel2.png.jpeg"
import hotel3 from "./Assets/hotel3.png.jpeg"
import hotel4 from "./Assets/hotel4.png.jpeg"
import hotel5 from "./Assets/hotel5.png.jpeg"
import "./hotelOwnerHotels.css"
export default function HotelOwnerDashLP() {
  const images = [hotel2, hotel3, hotel4, hotel5]
  
  
    return (
      <div className="flex flex-col h-[calc(100vh-80px)] w-full overflow-hidden carousel-image">
        <Carousel
          showThumbs={false}
          autoPlay
          infiniteLoop
          className="flex-grow max-h-full"
        >
          {images.map((imageDir, index) => (
            <div key={index} className="flex justify-center items-center w-full h-full overflow-hidden">
              <img
                src={imageDir}
                alt={`Slide ${index}`}
                className="object-cover w-full h-full max-h-[calc(100vh-80px)]"
              />
            </div>
          ))}
        </Carousel>
      </div>
    );
}